import { render, staticRenderFns } from "./ProjectInventoryList.vue?vue&type=template&id=4fe8e144&scoped=true"
import script from "./ProjectInventoryList.vue?vue&type=script&lang=js"
export * from "./ProjectInventoryList.vue?vue&type=script&lang=js"
import style0 from "./ProjectInventoryList.vue?vue&type=style&index=0&id=4fe8e144&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8e144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe8e144')) {
      api.createRecord('4fe8e144', component.options)
    } else {
      api.reload('4fe8e144', component.options)
    }
    module.hot.accept("./ProjectInventoryList.vue?vue&type=template&id=4fe8e144&scoped=true", function () {
      api.rerender('4fe8e144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/ProjectInventoryList.vue"
export default component.exports